import { render } from "./CreditorInfo.vue?vue&type=template&id=6dc6417d"
import script from "./CreditorInfo.vue?vue&type=script&lang=ts"
export * from "./CreditorInfo.vue?vue&type=script&lang=ts"
script.render = render

export default script